<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content d-flex flex-column transition overflow-hidden">
    <AdverseEventMessage />
    <router-view />
    <!-- <MainFooter /> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, watchEffect } from "vue";
import sidebarStore from "@/utils/sidebar.store";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import stateStore from "@/utils/store";
import { checkUserConsents } from "@/router/resolvers/user_consents.resolver";
import { Role } from "@/utils/models/user.model";
import OTPstore from "@/utils/otp.store";
import AdverseEventMessage from "@/components/FK/UserInfo/AdverseEventMessage.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    MainHeader,
    MainSidebar,
    AdverseEventMessage,
    /* MainFooter, */
  },
  async mounted() {
    document.body.classList.add("bg-body-secondary");
    await this.redirect();
  },
  unmounted() {
    document.body.classList.remove("bg-body-secondary");
  },
  setup() {
    const sidebarStoreInstance = sidebarStore;
    // const stateStoreInstance = stateStore;
    watchEffect(() => {
      if (sidebarStoreInstance.open) {
        document.body.classList.remove("sidebar-show");
        document.body.classList.add("sidebar-hide");
      } else {
        document.body.classList.remove("sidebar-hide");
        document.body.classList.add("sidebar-show");
      }

      if (stateStore.isAdmin() || stateStore.user?.info.role.type === Role.internal) {
        document.body.classList.add('admin');
      } else {
        document.body.classList.remove('admin');
      }
    });
    return {};
  },
  methods: {
    async redirect() {
      let pending = await checkUserConsents();
      if (pending.length !== 0) {
        this.$router.push({ path: '/user-consents' });
      } else {
        this.checkPatientRedirect();
      }
    },
    checkPatientRedirect() {
      let patient_id = OTPstore.getPatientID();
      if (patient_id) {
        OTPstore.clearPatientID();
        this.$router.push(`/patient/${patient_id}`);
      }
    }
  }
});
</script>